export default __webpack_public_path__ + "96e102d85870542c36e6d6ab84ef71cf.png";